'use strict';


export default function(incident) {
	incident.timestamps = {};
	for(var i=0, logLength = incident.log.length; i < logLength; i++) {
		var entry = incident.log[i];
		var event = entry.event;
		if (!incident.timestamps.hasOwnProperty(event)) {
			incident.timestamps[event] = entry.time;
		} else {
			// Decide what to do for repeated log entry events
			// team:global_formation_initialized
			// team:global_formation_failed
			// team:global_formation_complete
			// team:formation_paused
			// team:formation_resumed
			switch(event) {
				case 'team:global_formation_failed':
				case 'team:global_formation_complete':
					incident.timestamps[event] = entry.time;
					break;
			}
		}
	}
};
